// @ts-check
// import * as sentry from "./sentry"

export const baseURL = "https://www.familienunternehmen-politik.de/"

let _apiBaseURL =
    typeof window !== "undefined" && window.localStorage?.getItem("apiBase")

export const apiBaseURL = _apiBaseURL || "/api/"
export const sentryDSN = ""
export const sentryTracingOrigins = [
    "localhost",
    apiBaseURL,
    // more api trace urls here
    /^\//,
]
export const sentryEnvironment = "master"

export const startTeaser: {
    [sprache: string]: {
        bild: string
        titel: string
        text: string
        url: string
    }[]
} = {
    de: [
        {
            bild: "/media/startseite/box_ueber-die-stiftung.jpg",
            titel: "Über die Stiftung",
            text: "Die „Stiftung Familienunternehmen und Politik“ ist Ansprechpartner für die Politik in wirtschaftspolitischen, rechtlichen und steuerlichen Fragestellungen mit Bezug zu Familienunternehmen.",
            url: "/de/ueber-uns/die-stiftung-familienunternehmen-und-politik",
        },
        {
            bild: "/media/startseite/haus-fu_box2.jpg",
            titel: "Haus des Familienunternehmens",
            text: "Das „Haus des Familienunternehmens“ ist ein Ort der Begegnung und des Austauschs von Politik, Wissenschaft sowie Vertretern von Familienunternehmen.",
            url: "/de/haus-des-familienunternehmens",
        },
        {
            bild: "/media/startseite/box_team.jpg",
            titel: "Das Team",
            text: "Die Fachleute der „Stiftung Familienunternehmen und Politik“ stehen für Politik und Medien als Ansprechpartner zur Verfügung.",
            url: "/de/ueber-uns/team",
        },
    ],
    en: [
        {
            bild: "/media/startseite/box_ueber-die-stiftung_en.jpg",
            titel: "About the Foundation",
            text: "The Foundation for Family Businesses and Politics supports family businesses in a variety of ways.",
            url: "/en/about-us/foundation-for-family-businesses-and-politics",
        },
        {
            bild: "/media/startseite/haus-fu_box2.jpg",
            titel: "The House of Family businesses",
            text: "The House of Family Businesses is a place for meetings and exchanges among politicians, the media, academia and representatives of family businesses.",
            url: "/en/the-house-of-family-businesses",
        },
        {
            bild: "/media/startseite/box_team.jpg",
            titel: "Team",
            text: "The specialists at the Foundation for Family Businesses and Politics are happy to serve as contacts for politicians and the media.",
            url: "/en/about-us/team",
        },
    ],
}

export const leitbild = {
    de: {
        author: "Prof. Rainer Kirchdörfer und Dr. Ulrich Stoll",
        title: "„Politik beginnt mit der Betrachtung der Wirklichkeit“",
        teasertext:
            "Dieser Satz des großen Sozialdemokraten Kurt Schumacher ist aktueller denn je. Faktenbasierte Entscheidungen zu ermöglichen, dieses Ziel leitet die Stiftung Familienunternehmen und Politik.",
        link: "/de/leitbild",
        image: "/media/startseite/leitbild.jpg",
    },
    en: {
        author: "Prof. Rainer Kirchdörfer and Dr. Ulrich Stoll",
        title: '"Politics begins with the consideration of reality."',
        teasertext:
            "This statement by the great social democrat Kurt Schumacher is more topical than ever. The objective of enabling fact-based decisions guides the work of the Foundation for Family Businesses and Politics.",
        link: "/en/mission-statement",
        image: "/media/startseite/leitbild.jpg",
    },
}

// Übersetzungen
export const uebersetzungen: {
    [key: string]: {
        [sprache: string]: string
    }
} = {
    Suche: { en: "Search" },
    mehr: { en: "more" },
    Positionen: { en: "Positions" },
    Aktuelles: { en: "News" },
    "Über uns": { en: "About us" },
    "Unternehmer-Standpunkte": { en: "todo" },
    "alle Positionen": { en: "all Positions" },
    "alle Meldungen": { en: "all articles" },
    Adresse: { en: "Address" },
    Übersicht: { en: "Overview" },
    Service: { en: "Service" },
    "Folgen Sie uns": { en: "Follow us" },
    Telefon: { en: "Phone" },
    Telefax: { en: "Fax" },
    Themen: { en: "Topics" },
    Kontakt: { en: "Contact" },
    Presse: { en: "Press" },
    "Weitere Informationen": { en: "Further information" },
    "Leitbild der Stiftung Familienunternehmen und Politik": {
        en: "Mission Statement of the Foundation for Family Businesses and Politics",
    },
    "keine Treffer für": { en: "no hits for" },
    "Stiftung Familienunternehmen und Politik": {
        en: "Foundation for Family Businesses and Politics",
    },
    "Stiftung Familienunternehmen": {
        en: "Foundation for Family Businesses",
    },
    "Haus des Familienunternehmens": {
        en: "The House of Family Businesses",
    },
    "Haus des Familienunternehmens Brüssel": {
        en: "Brussels House of Family Businesses",
    },
    "Folgende Ergebnisse wurden für Ihr Suchwort gefunden": {
        en: "Following results were found for your search",
    },
    "Cookie-Einstellungen öffnen": {
        en: "open cookie settings",
    },
}

// need to execute early for fetch wrapping
// will be uncommented via drone CI
// sentry.init(sentryDSN, sentryTracingOrigins, sentryEnvironment)
